import { AfterContentInit, ElementRef, EventEmitter, OnInit, Renderer2 } from '@angular/core';
import { bindFunctionsToThis } from '../../extensions';
var WaterFallContainerComponent = /** @class */ (function () {
    function WaterFallContainerComponent(render) {
        this.render = render;
        this._reLayoutDelay = 200;
        this._2timesWidthItemIndexes = [];
        this.isInitialLayoutCompleted = false;
        this.horizonPadding = 5;
        this.itemWidth = 200;
        this.itemMaxWidth = 250;
        this.maxColumnCount = 6;
        this.gap = 16;
        this.isRandom2TimesWidthCard = false;
        this.modernBlockStyle = false;
        this.onLoadMore = new EventEmitter();
        bindFunctionsToThis(this);
    }
    Object.defineProperty(WaterFallContainerComponent.prototype, "isScrolledToEnd", {
        get: function () {
            if (!this.container) {
                return false;
            }
            var _a = this.container.nativeElement, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            return scrollHeight - scrollTop === clientHeight;
        },
        enumerable: true,
        configurable: true
    });
    WaterFallContainerComponent.prototype.ngAfterContentInit = function () {
        this.render.listen(this.container.nativeElement, 'scroll', this.onScroll);
        setTimeout(this.reLayout, 0);
    };
    WaterFallContainerComponent.prototype.startLoading = function () {
        this.isLoadingItems = true;
    };
    WaterFallContainerComponent.prototype.onScroll = function () {
        if (this.isLoadingItems || this.isAllItemsLoaded) {
            return;
        }
        var _a = this.container.nativeElement, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
        if (scrollHeight - scrollTop < clientHeight * 4) {
            this.onLoadMore.emit({ loadMore: this.loadItems });
            this.isLoadingItems = true;
        }
    };
    WaterFallContainerComponent.prototype.reLayout = function (isLoadMoreItems) {
        var _this = this;
        if (isLoadMoreItems === void 0) { isLoadMoreItems = false; }
        if (!!this._reLayoutTimer) {
            clearTimeout(this._reLayoutTimer);
        }
        var container = this.container.nativeElement;
        var containerWidth;
        this._reLayoutTimer = setTimeout(function () {
            var layout = function () {
                containerWidth = container.clientWidth;
                var children = Array.prototype.slice.call(container.children);
                var columnCount = Math.floor(containerWidth / (_this.itemWidth + _this.gap));
                columnCount = Math.min(columnCount, _this.maxColumnCount) || 1;
                var remainWidth = (containerWidth) - columnCount * (_this.itemWidth + _this.gap);
                var extractWidthForEachItem = remainWidth / columnCount;
                var _2TimesWidthItemWidth = (_this.itemWidth + extractWidthForEachItem) * 2 + _this.gap + "px";
                var layoutPendingItems = children;
                if (isLoadMoreItems) {
                    layoutPendingItems = children.slice(_this._currentItemCount);
                }
                else {
                    _this._columnOffsets = new Array(columnCount);
                    _this._columnOffsets.fill(0, 0);
                    //this._2timesWidthItemIndexes = [];
                }
                //if (columnCount && layoutPendingItems.length && (this._currentItemCount !== children.length)) {
                if (_this.isRandom2TimesWidthCard) {
                    columnCount--;
                    layoutPendingItems.filter(function (x) { return x.nodeName.toLowerCase() === 'div'; }).forEach(function (x) { return x.remove(); });
                    layoutPendingItems = layoutPendingItems.filter(function (x) { return x.nodeName.toLowerCase() !== 'div'; });
                    var rowCount = Math.ceil(layoutPendingItems.length / columnCount);
                    for (var i = 0; i < rowCount - 1; i++) {
                        var arr = [];
                        for (var j = i * columnCount; j <= columnCount * (i + 1) - 1; j++) {
                            arr.push(j);
                        }
                        var random = arr.getRandom();
                        if ((i + 1) > _this._2timesWidthItemIndexes.length) {
                            _this._2timesWidthItemIndexes.push(random);
                            layoutPendingItems[random].style.width = _2TimesWidthItemWidth;
                            layoutPendingItems[random].style.zIndex = 2;
                        }
                        else {
                            layoutPendingItems[_this._2timesWidthItemIndexes[i]].style.width = _2TimesWidthItemWidth;
                            layoutPendingItems[_this._2timesWidthItemIndexes[i]].style.zIndex = 2;
                        }
                    }
                    _this._2timesWidthItemIndexes.forEach(function (random, index) {
                        if (random + (1 + index) < layoutPendingItems.length) {
                            var div = document.createElement('div');
                            div.style.height = layoutPendingItems[random].clientHeight + 'px';
                            container.insertBefore(div, layoutPendingItems[random + (1 + index)]);
                            layoutPendingItems.splice(random + (1 + index), 0, div);
                        }
                    });
                }
                //}
                var itemHeights = layoutPendingItems.map(function (item) { return item.clientHeight; });
                // Hide container to increase re-layout performance
                container.style.display = 'none';
                children.forEach(function (item) { return item.style.transition = ''; });
                _this.loadNewStyle(extractWidthForEachItem);
                layoutPendingItems.forEach(function (item, index) {
                    var _a = _this.getShortestColumnOffset(), offsetTop = _a.offsetTop, columnIndex = _a.columnIndex;
                    var left = _this.horizonPadding +
                        (_this.itemWidth + extractWidthForEachItem) * columnIndex
                        + _this.gap * columnIndex;
                    if (isLoadMoreItems) {
                        item.style.transform = "translate(" + left + "px, " + offsetTop + "px) scale(0)";
                        setTimeout(function () {
                            item.style.transition = 'transform .2s linear';
                            item.style.transform = "translate(" + left + "px, " + offsetTop + "px) scale(1)";
                        }, 0);
                    }
                    else {
                        item.style.transform = "translate(" + left + "px, " + offsetTop + "px)";
                    }
                    _this._columnOffsets[columnIndex] += itemHeights[index] + _this.gap;
                });
                _this._currentItemCount = children.length;
                container.style.display = '';
            };
            if (!_this.modernBlockStyle) {
                layout();
            }
            setTimeout(function () {
                // After first layout, check if the vertical scroll bar shown, then layout again
                if (containerWidth && (containerWidth >= container.clientWidth)) {
                    layout();
                }
                _this.isInitialLayoutCompleted = true;
                _this.isLoadingItems = false;
            }, _this._reLayoutDelay);
        }, this._reLayoutDelay);
    };
    WaterFallContainerComponent.prototype.loadItems = function () {
        var _this = this;
        setTimeout(function () {
            _this.reLayout(true);
        }, 0);
    };
    WaterFallContainerComponent.prototype.getShortestColumnOffset = function () {
        var offsetTop = this._columnOffsets[0];
        var columnIndex = 0;
        for (var i = 1; i < this._columnOffsets.length; i++) {
            if (this._columnOffsets[i] < offsetTop) {
                offsetTop = this._columnOffsets[i];
                columnIndex = i;
            }
        }
        return { offsetTop: offsetTop, columnIndex: columnIndex };
    };
    WaterFallContainerComponent.prototype.loadNewStyle = function (extractWidthForEachItem) {
        var previousStyle = document.querySelector('#water-fall-container');
        if (!!previousStyle) {
            try {
                previousStyle.remove();
            }
            catch (error) {
                previousStyle.parentNode.removeChild(previousStyle);
            }
        }
        var style = document.createElement('style');
        style.id = 'water-fall-container';
        style.type = 'text/css';
        style.innerHTML = "\n            .water-fall-container > * {\n                width: " + (this.itemWidth + extractWidthForEachItem) + "px;\n            }";
        document.getElementsByTagName('head')[0].appendChild(style);
    };
    return WaterFallContainerComponent;
}());
export { WaterFallContainerComponent };
var WaterFallLoadMoreEvent = /** @class */ (function () {
    function WaterFallLoadMoreEvent() {
    }
    return WaterFallLoadMoreEvent;
}());
export { WaterFallLoadMoreEvent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/water.fall.container/water.fall.container.component.ts.pre-build-optimizer.js